import React from 'react'

import SiteHeader, { SiteHeaderProps } from 'lib/components/SiteHeader/SiteHeader'

import { useSiteHeader } from '@/hooks/useSiteHeader'
import { brand } from '@/utils/brand'

interface SiteHeaderWrapperProps {
  type?: SiteHeaderProps['type']
}

const SiteHeaderWrapper: React.FC<SiteHeaderWrapperProps> = ({ type = 'primary' }) => {
  const siteHeaderProps = useSiteHeader(type)

  // Shipplay mounts its own SiteNav / SiteUserBar via SiteLayout in ClientLayout.
  // Pages that inline <SiteHeaderWrapper /> (gift-cards, privacy, terms, refer,
  // claims, reviews, partner-agreement-terms) would otherwise render the legacy
  // SiteHeader on top of the new chrome for shipplay.
  if (brand.key === 'shipplay') return null

  return <SiteHeader {...siteHeaderProps} />
}

export default SiteHeaderWrapper
